import { render, staticRenderFns } from "./AdminSoftwareOfferStats.vue?vue&type=template&id=36c3f242"
import script from "./AdminSoftwareOfferStats.vue?vue&type=script&lang=ts"
export * from "./AdminSoftwareOfferStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports